import { useRouter } from 'next/router';

export const validateToken = async (apiUrl, token) => {

  try {
    if (!token) {
      return false;
    }
    // Make API call to backend to validate token
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.error('Token validation response not ok');
      return false;
    }

    const data = await response.json();
    return data.valid;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

export const useAuthCheck = () => {
  const router = useRouter();

  const checkAuth = async () => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;
    
    if (!await validateToken(token)) {
      if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
      }
      
      router.push('/login');
      return false;
    }
    
    return true;
  };

  return checkAuth;
};
